import { render } from "./PostCreate.vue?vue&type=template&id=38c0434e"
import script from "./PostCreate.vue?vue&type=script&lang=js"
export * from "./PostCreate.vue?vue&type=script&lang=js"

import "./PostCreate.vue?vue&type=style&index=0&id=38c0434e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__